/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import Select from 'react-select';
import serialize from 'form-serialize';
import ReactTooltip from 'react-tooltip';
import { ToastContainer, toast } from 'react-toastify';
import queryString from 'query-string';
import Pagination from './Pagination';
import * as tableOnSteroidsActions from '../../actions/tableOnSteroids';
import TableHeader from './TableOnSteroids/TableHeader';
import FilterField from './TableOnSteroids/FilterField';
import './TableOnSteroids/table_on_steroids_v3.scss';
import '../../../../javascript/styles/stylesheets/table_on_steroids_v4.scss';

import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from 'react-router-dom';
import { trackEvent } from '../../../lib/analytics';
import { translate as t } from '../../../lib/translate';
import Modal from 'react-responsive-modal';
import classNames from 'classnames';

function mapStateToProps(state, ownProps) {
  const defaultTableProps = {
    columns: {},
    lastPage: 10000,
    objects: {},
    order: { column: null, ascending: false },
    page: 1,
    query: {},
    selectedColumns: ownProps.defaultColumns,
    selectedObjects: {},
    isAgentDashboard: false,
    csvDownloadable: true
  };

  const currentTableProps = state.tableOnSteroids[ownProps.tableId] || defaultTableProps;

  return _.pick(currentTableProps, [
    'columns',
    'downloadCsv',
    'asyncCsv',
    'csvDownloadable',
    'error',
    'ids',
    'lastPage',
    'loading',
    'objects',
    'order',
    'page',
    'query',
    'selectedColumns',
    'selectedObjects',
    'totalCount'
  ]);
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(tableOnSteroidsActions, dispatch);
}


class TableOnSteroids extends React.Component {
  static ALLOWED_PARAMS = ['offer','status_and_actions','vetting','application', 'internal_review_assignee'];

  constructor(...props) {
    super(...props);
    this.successToast = this.successToast.bind(this);
    this.errorToast = this.errorToast.bind(this);
    this.setOrder = this.setOrder.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.globalSearch = this.globalSearch.bind(this);
    this.handleObjectSelection = this.handleObjectSelection.bind(this);
    this.firstObjectsLoad = true;
    this.triggerRefreshTable = this.triggerRefreshTable.bind(this);
    this.state = { csv: { queued: false, email: '' },
      selectedObjects: {},
      url: this.props.url,
      query: null,
      allPagesSelected: false
    };
  }



  getQueryStringParams() {
    return queryString.parse(this.props.location.search);
  }

  getUrlParams() {
    let urlParams = {};
    const queryStringParams = this.getQueryStringParams();
    let availableColumns = this.selectedColumns();
    availableColumns.push('order', 'order_ascending', 'page');
    if (Object.keys(queryStringParams).length) {
      urlParams = Object.keys(queryStringParams)
        .filter(key => availableColumns
          .flatMap((col) => [col, `search_${col}`, `search_operator_${col}`])
          .includes(key))
        .reduce((obj, key) => {
          obj[key] = queryStringParams[key];
          return obj;
        }, {});
      urlParams = _.merge({}, urlParams, { knowledge: { order: urlParams.order, ascending: urlParams.order_ascending }, page: parseInt(urlParams.page, 10) });
    }
    return urlParams;
  }

  componentDidMount() {
    let opts = { loading: true };
    const { objectParam, match } = this.props;
    const currentItemId = match.params && match.params[objectParam];
    const query = _.merge({}, opts, this.getUrlParams());
    if (currentItemId && objectParam) {
      opts.extraParams = { current_item_id: currentItemId };
    }
    this.fetchObjects({ query });
    this.props.setCurrentTableId(this.props.tableId);
  }

  componentDidUpdate(prevProps) {
    const { objects, match, objectParam } = this.props;
    const currentItemId = match.params && match.params[objectParam];

    if (prevProps.objectsUrl != this.props.objectsUrl) {
      this.props.dropTable(this.props.tableId);
      const query = this.getUrlParams();

      this.fetchObjects({ query, loading: true });
    }

    if (Object.keys(objects).length && this.firstObjectsLoad) {
      this.scrollToRef(currentItemId);
      this.firstObjectsLoad = false;
    }
    //window.jQuery('.selectpicker').selectpicker();
  }

  scrollToRef(identifier) {
    if (!identifier || !this.refs[identifier]) {
      return (null);
    }
    setTimeout(() => {
      this.refs[identifier].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 1500);
  }

  async fetchObjects(opts = {}) {
    const returnTableFilters = this.props.returnTableFilters;
    const url = this.props.objectsUrl;
    const page = opts.page || this.props.page || 1;
    const query = opts.query || { ...this.props.query, page };
    const objects = this.props.objects;
    const actionItemId = opts.actionItemId || null;
    opts = { ...opts, url, query, objects, tableId: this.props.tableId, page, objectType: this.props.objectType, isAgentDashboard: this.props.isAgentDashboard };
    

    await this.props.fetchObjects(opts);

    const selectedObjects = this.state.selectedObjects;
    this.setState({url: url, query: query});
    
    if(returnTableFilters) {
      returnTableFilters(url, query, selectedObjects);
    }

    if (query.page) {
      // set the page as URL param
      const params = new URLSearchParams(window.location.search);
      params.set('page', query.page);
      window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
    }

    if(actionItemId)
      this.scrollToRef(actionItemId);
  }

  searchComponent() {
    const { componentMap, searchComponent } = this.props;
    if (searchComponent) {
      const SearchComponent = componentMap[searchComponent];
      return (<SearchComponent />);
    }
  }

  selectedColumns() {
    const queryParams = this.getQueryStringParams();
    const paramKeys = Object.keys(queryParams).map((key) => key.replace(/^search_/, '')).filter((key) => !key.startsWith('modal_') && Object.keys(this.props.columns).includes(key));
    let columns = (this.props.selectedColumns || (this.props.defaultColumns.filter(x => new Set(Object.keys(this.props.columns)).has(x))));
    return [...new Set([...columns, ...paramKeys])]
  }

  columnSelector() {
    const { columns, updateSelectedColumns, tableId } = this.props;
    const validColumns = Object.keys(columns).filter(columnKey => ( (columns[columnKey]) ? columnKey : null));
    const options = Object.keys(columns).map(columnKey => ({ label: columns[columnKey].label, value: columnKey }));
    const selectedOptions = this.selectedColumns().map(columnKey => ({ label: columns[columnKey].label, value: columnKey }));

    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#70abdd' : 'white'
      }),

    };

    return (
      <div className="column_filter">
        <Select styles={customStyles} options={options} placeholder="columns" defaultValue={selectedOptions} hideSelectedOptions={false} classNamePrefix="column"
          isMulti onChange={(options) => { updateSelectedColumns(options.map(option => option.value), { tableId }); }}
        />
      </div>);
  }

  csvDownloader() {
    const downloadLink = this.props.downloadCsv;

    return (
      <div className="download-csv">
        {(downloadLink && downloadLink != undefined) ?
          <div className="download" onClick={this.handleDownload} >
            <img src={require('../../../images/am_tool/google-csv')} />
          </div>
          : //else
          null
        }
        <Modal open={this.state.csv.queued} onClose={() => this.setState({ csv: { queued: false, email: '' } })} center>
          <h2>CSV Export</h2>
          <p>The CSV export is being generated. It will be sent to {this.state.csv.email} when it is ready!</p>
        </Modal>
      </div>
    );
  }

  globalSearchBox(defaultValue) {
    const formId = `form_${this.props.tableId}`;
    return (
      <div className="table_on_steroids_search global_search_box">
        <input form={formId} type="text" data-currentvalue={defaultValue} onFocus={(e) => e.target.setAttribute('data-currentvalue', e.target.value)} onKeyPress={(e) => this.handleKeyPress(e, 'Global Search')} onBlur={(e) => this.globalSearch(e)} name={"search"} defaultValue={defaultValue} placeholder="Search.." className="form-control steroid-filter form-field-text" />
      </div>);
  }

  columnFilters() {
    const { columns, selectRows, query, tableId } = this.props;
    const params = this.getQueryStringParams();
    query.filters = _.merge({}, query.filters, _.pick(params, ...TableOnSteroids.ALLOWED_PARAMS));

    const filters = this.selectedColumns()
      .map(columnKey => {
        const currentColumn = columns[columnKey];

        const tooltip = currentColumn.hasOwnProperty('tooltip') ? 
            <div className={`fa fa-${currentColumn.tooltip.icon}`} data-tip={currentColumn.tooltip.text}>
              <ReactTooltip effect='solid' />
            </div> : null;

        if(!currentColumn) {
          return null;
        }
        if (
          currentColumn.activerecord && currentColumn.activerecord.search_lambda ||
          currentColumn.array && currentColumn.array.search_lambda ||
          currentColumn.type == "filter"
        ) {
          return (
            <td className={`${currentColumn.css_class} order column table-on-steroid-filter-td column-${columnKey}`}
              key={`header_${columnKey}`}>
              <FilterField
                query={query}
                applyFilters={this.applyFilters}
                handleKeyPress={(e) => this.handleKeyPress(e, 'Column Filter')}
                tableId={tableId}
                columnKey={columnKey}
                currentColumn={currentColumn}
                filterable={!!currentColumn.filterable_content}
              />
              { tooltip }
            </td>
          );
        }
        return <td key={`header_${columnKey}`}>{tooltip}</td>;
      }).filter(f => f);
    if (filters.length) {
      return <tr className="filter-tr">{selectRows ? <td /> : null}{filters}</tr>;
    }
    return null;
  }

  globalSearch(e) {
    if (e.target.value!=e.target.dataset.currentvalue) {
      this.applyFilters('Global Search');
    }
  }

  async applyFilters(filterType) {
    const { filterFormRef } = this.refs;
    const formValues = serialize(filterFormRef, { hash: true, empty: false });
    const query = {
      ...formValues,
      knowledge: { order: this.props.order.columnKey, ascending: this.props.order.ascending }
    };
    trackEvent(`Table ${filterType || 'Column Filter'}`, 'Campaign Management');
    this.setCurrentFocus('');
    await this.fetchObjects({ query, page: 1, loading: true });
  }

  handleKeyPress = (e, filterType) => {
    if (e.key === 'Enter' && e.target.value!=e.target.dataset.currentvalue) {
      e.target.setAttribute('data-currentvalue', e.target.value);
      e.preventDefault();
      this.applyFilters(filterType);
    }
  }

  handleDownload = (e) => {
    e.preventDefault();
    trackEvent('Table CSV Download', 'Campaign Management');
    let downloadLink = this.props.downloadCsv;
    const form = document.querySelector(`#form_${this.props.tableId}`);
    downloadLink += ((downloadLink.includes("?")) ? "&" : "?") + serialize(form);
    if (this.props.asyncCsv) {
      fetch(`${downloadLink}&async_csv=true`).then(response => response.json()).
        then(data => { this.setState({ csv: { queued: data.queued, email: data.email } }); });
    } else {
      window.open(downloadLink, '_blank');
    }
  }

  handleObjectSelection = (objects, selectObjects, unSelectObjects, checked, selectAllPages) => {
    const rowKeys = this.props.ids || Object.getOwnPropertyNames(objects);
    const { returnTableFilters, tableId, disableToolbarOnSelect } = this.props;
    let currentSelectedObjects = this.state.selectedObjects;

    rowKeys.forEach((key) => {
      const object = objects[key];
      if(checked)
        currentSelectedObjects[key] = object;
      else
        delete currentSelectedObjects[key];
    });

    const opts = { tableId };
    if (disableToolbarOnSelect) {
      opts.skipToolbar = true;
    }

    if(checked)
      selectObjects(objects, opts);
    else
      unSelectObjects(objects, { tableId } );

    this.setState({ selectedObjects: currentSelectedObjects, allPagesSelected: selectAllPages });

    if(returnTableFilters)
      returnTableFilters(this.state.url, this.state.query, this.state.selectedObjects, selectAllPages);

  }

  row(object, identifier) {
    const {
      componentMap,
      selectType,
      columns,
      selectedObjects,
      tableId,
      selectObjects,
      unSelectObjects,
      selectRows,
      returnTableFilters,
      page
    } = this.props;
    
    const objectColumn = this.selectedColumns().map(columnKey => {
      const currentColumn = columns[columnKey];
      if(!currentColumn) {
        return null;
      }
      if (currentColumn.value_attr) {
        return (
          <td className={`${currentColumn.css_class} column column-${columnKey}`} key={`cell_${columnKey}_object${object.id}`}>
            {object[currentColumn.value_attr]}
          </td>
        );
      }
      const CellComponent = componentMap[currentColumn.component];

      if (!CellComponent) {
        throw new Error(`Missing component map entry for ${currentColumn.component}`);
      }

      const cellProps = currentColumn.extra_props || {};
      cellProps[currentColumn.prop_name] = object;

      return (
        <td
          className={`${currentColumn.css_class} column column-${columnKey}`}
          key={`cell_${columnKey}_object${object.id}`}
        >
          <CellComponent
            {...cellProps}
            tableId={this.props.tableId}
            successToast={this.successToast}
            errorToast={this.errorToast}
            page={page}
            triggerRefreshTable={this.triggerRefreshTable}
          />
        </td>
      );
    });
    const objectWithIdentifier = {};
    objectWithIdentifier[identifier] = object;
    return (
      <tr key={`object-${identifier}`} id={`${tableId}_${identifier}`} ref={identifier} className={object.error ? "error" : ""} onClick={() => { this.setCurrentFocus(identifier); }}>
        {selectRows ? <td className="checkbox">
          {object.error ? <div className="fa fa-exclamation-circle" data-tip={`An error occured: ${object.error}`}><ReactTooltip effect='solid' /></div> : null}
          <input name={`selected-${selectType}`} type="checkbox" value={identifier}
            checked={Object.keys(selectedObjects).includes(identifier)}
            onChange={(e) => {
              let currentSelectedObjects = this.state.selectedObjects;
              const { disableToolbarOnSelect } = this.props;
              const opts = { tableId };
              if (disableToolbarOnSelect) {
                opts.skipToolbar = true;
              }
              if(e.target.checked) {
                currentSelectedObjects[identifier] = object;
                this.setState({ selectedObjects: currentSelectedObjects });
                selectObjects(objectWithIdentifier, opts);
                if(returnTableFilters)
                  returnTableFilters(this.state.url, this.state.query, currentSelectedObjects, this.state.allPagesSelected);
              } else {
                delete currentSelectedObjects[identifier];
                this.setState({ selectedObjects: currentSelectedObjects, allPagesSelected: false });
                unSelectObjects(objectWithIdentifier, { tableId });
                if(returnTableFilters)
                  returnTableFilters(this.state.url, this.state.query, currentSelectedObjects, false);
              }
            }}
          ></input>
        </td>
          : null}
        {objectColumn}
      </tr>
    );
  }

  toastWithColor(color, message) {
    toast(
      message,
      {
        position: toast.POSITION.BOTTOM_LEFT,
        className: `toast bg-${color}`,
        autoClose: 3000,
      }
    );
  }

  successToast(message) {
    this.toastWithColor('success', message);
  }

  errorToast(message) {
    this.toastWithColor('danger', message);
  }

  triggerRefreshTable(id) {
   this.fetchObjects({page: this.props.page, loading: true, actionItemId: id});
  }

  async setOrder(columnKey, direction) {
    const ascending = (direction == 'ascending');
    const tableId = this.props.tableId;

    await this.props.setOrder({ columnKey, ascending, tableId });
    await this.applyFilters();
  }

  setCurrentFocus(identifier) {
    let path = this.props.match.path;
    const { objectParam } = this.props;
    if (!objectParam) {
      return;
    }
    path = path.includes(`:${objectParam}?`) ? path.replace(`:${objectParam}?`, identifier) : `${path}/${identifier}`;
    this.props.history.push(path);
  }

  render() {
    const {
      columns,
      error,
      ids,
      loading,
      objects,
      order,
      query,
      selectObjects,
      selectRows,
      selectAllPagesEnabled,
      selectedObjects,
      tableId,
      unSelectObjects,
      lastPage
    } = this.props;

    let { scrollToTop = true } = this.props;

    let errorMsg = null;
    if (error) {
      errorMsg = <div className="error-message">Uh oh... an error occurred while fetching objects: {error}</div>;
      if (!Object.keys(columns).length) {
        return (<div className="table-on-steroid">{errorMsg}</div>);
      }
    }
    if (!Object.keys(columns).length) {
      return (<div className="table-on-steroid-v4"><div className="loading-box loading" /></div>);
    }
    if (!Object.keys(objects).length && (!query || Object.keys(query).length < 2)) {
      return (<div className={`table-on-steroid-v3 ${this.props.className}`} >
        {this.props.hideTopInfo ? null : <div className="top-info">
          {this.props.influencerCampaignTable ? <h4>{this.props.title}</h4>
            : <div className="col-md-5 title">{this.props.title} ({this.props.totalCount})</div>}
          {this.props.hideSearch
            ? null
            : <React.Fragment>
              <div className="col-md-3">{this.globalSearchBox("")}</div>
              <div className={classNames({
                "col-md-4": !this.props.csvDownloadable,
                "col-md-2": this.props.csvDownloadable,
              })}>{this.columnSelector()}</div>
              {this.props.csvDownloadable && (<div className="col-md-2">{this.csvDownloader()}</div>)}
            </React.Fragment>
          }
        </div>}
        <div className="no-data">
          {this.props.noDataContent ? this.props.noDataContent : this.props.influencerCampaignTable ?
            <div className="card mt-4">
              <div className="card-body p-5 m-auto">
                <p className="m-5">{t('influencers.pages.analytics.no_campaigns_yet')}</p>
              </div>
            </div>
            :
            <React.Fragment>
              <img width="100px" src={require('../../../images/am_tool/no_data')} />
              <div>There is no one in this stage of the pipeline.</div>
            </React.Fragment>
          }
        </div>
      </div>);
    }

    const rowKeys = ids || Object.getOwnPropertyNames(objects);
    const tBody = (
      <tbody className="text-1">
        {rowKeys.map(key => this.row(objects[key], key))}
      </tbody>
    );

    const styleVersion = this.props.styleVersion || 'v3';

    console.log('frontend TableOnSteroids.jsx: styleVersion', styleVersion);


    if (scrollToTop && (loading || error)) {
      $("html").scrollTop(0);
    }
    const allChecked = Object.keys(selectedObjects).filter(n => Object.keys(objects).includes(n)).length == Object.keys(objects).length;

    //onChange={(e) => { e.target.checked ? selectObjects(objects, { tableId }) : unSelectObjects(objects, { tableId }); }}
                
    const selectAllPagesCheckBox = (
      <div>
        <label>
          <input type="checkbox"
            checked={this.state.allPagesSelected}
            onChange={(e) => { this.handleObjectSelection(objects, selectObjects, unSelectObjects, e.target.checked, e.target.checked) }}
          ></input>
          <span className="select-all-label">Select all rows matching the filters</span>
        </label>
      </div>
    );

    const tHead = (<thead>
      <tr>
        {selectRows ?
          <th className="select-all">
            <label>
              <input type="checkbox"
                checked={allChecked}
                onChange={(e) => { this.handleObjectSelection(objects, selectObjects, unSelectObjects, e.target.checked, this.state.allPagesSelected ) }}
              ></input>
            </label>
          </th>
          : null}
        <TableHeader
          selectedColumns={this.selectedColumns()}
          setOrder={this.setOrder}
          orderColumn={order.columnKey}
          orderAscending={order.ascending}
          {..._.pick(this.props,
            'columns',
            'query',
            'tableId',
          )}
        />
      </tr>
      {this.props.hideFilters ? null : this.columnFilters()}
    </thead>
    );

    return (
      <div className={`table-on-steroid-${styleVersion} ${this.props.className}`} key={"table-on-steroid-" + ''} >
        {errorMsg}
        {this.props.hideTopInfo ? null : <div className="top-info">
          {this.props.influencerCampaignTable ? <h3>{this.props.title}</h3>
            : <div className="col-md-5 title">{this.props.title} ({this.props.totalCount})</div>}
          {this.props.hideSearch
            ? null
            : <React.Fragment>
              <div className="col-md-3">{this.globalSearchBox("")}</div>
              <div className={classNames({
                "col-md-4": !this.props.csvDownloadable,
                "col-md-2": this.props.csvDownloadable,
              })}>{this.columnSelector()}</div>
              {this.props.csvDownloadable && (<div className="col-md-2">{this.csvDownloader()}</div>)}
            </React.Fragment>
          }
        </div>}
        <form id={`form_${this.props.tableId}`} ref={'filterFormRef'} />
        <div className='table-container'>
          {loading ? null : selectAllPagesEnabled ? selectAllPagesCheckBox : null}
          <table className={`table knowledge-table${selectRows ? '' : ' no-checkbox'}`}>
            {loading ? null : tHead}
            {loading ? null : tBody}
          </table>
        </div>
        {loading ? <div className="loading-box loading" /> : null}
        <ToastContainer />
        {loading ? null :
          <Pagination
            currentPage={this.props.page}
            lastPage={this.props.lastPage}
            fetchData={page => { this.setCurrentFocus(''); this.fetchObjects({ page, loading: true }); }}
            customClasses={['internal-dashboard-pagination-customs']}
          />}
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableOnSteroids));

TableOnSteroids.propTypes = {
  componentMap: PropTypes.object.isRequired,
  objectsUrl: PropTypes.string.isRequired,
  tableId: PropTypes.string.isRequired,
  defaultColumns: PropTypes.array.isRequired,
  fetchObjects: PropTypes.func.isRequired,
  updateSelectedColumns: PropTypes.func.isRequired,
  selectObjects: PropTypes.func.isRequired,
  unSelectObjects: PropTypes.func.isRequired,
  setCurrentTableId: PropTypes.func.isRequired,
};
